import {
  EyeOutlined,
  PlayCircleOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import { Badge, Button, Input, Select, Tooltip } from 'antd';
import React from 'react';
import ReactCountryFlag from 'react-country-flag';
import { LANGUAGES } from '../../../../utils/const/languages';
import {
  MAPPING_TYPES_UI,
  REQUIREMENT_OPTIONS,
} from '../../../../utils/const/mapping';

const AttributeFilters = ({
  search,
  setSearch,
  filterLang,
  setFilterLang,
  filterType,
  setFilterType,
  filterRequirement,
  setFilterRequirement,
  onTransformAll,
  onPreviewMapping,
  isTransformDisabled,
  isPreviewDisabled,
  isTransformLoading,
  isPreviewLoading,
}) => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 16,
        gap: 16,
      }}
    >
      <div style={{ display: 'flex', gap: 16, flex: 1 }}>
        <Input
          size="small"
          value={search}
          placeholder="Rechercher un champ"
          prefix={<SearchOutlined />}
          onChange={(e) => setSearch(e.target.value)}
          style={{ width: 300 }}
          allowClear
        />
        <Select
          size="small"
          value={filterLang}
          placeholder="Filtrer par langue"
          allowClear
          style={{ width: 200 }}
          onChange={(value) => setFilterLang(value)}
          options={[
            ...LANGUAGES.map((lang) => ({
              label: (
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <ReactCountryFlag
                    countryCode={lang.countryCode}
                    svg
                    style={{
                      width: '1.5em',
                      height: '1.5em',
                    }}
                  />
                  {lang.label}
                </div>
              ),
              value: lang.code,
            })),
          ]}
        />
        <Select
          size="small"
          value={filterType}
          placeholder="Filtrer par type"
          allowClear
          style={{ width: 200 }}
          onChange={(value) => setFilterType(value)}
          options={[
            ...Object.entries(MAPPING_TYPES_UI).map(([key, config]) => ({
              label: config.label,
              value: key,
            })),
          ]}
        />
        <Select
          size="small"
          value={filterRequirement}
          placeholder="Filtrer par exigence"
          allowClear
          style={{ width: 200 }}
          onChange={(value) => setFilterRequirement(value)}
          options={REQUIREMENT_OPTIONS.map((option) => ({
            label: <Badge color={option.color} text={option.label} />,
            value: option.name ?? '',
          }))}
        />
        <Button
          size="small"
          type="primary"
          onClick={() => {
            setSearch('');
            setFilterLang(null);
            setFilterType(null);
            setFilterRequirement(null);
          }}
        >
          Réinitialiser
        </Button>
      </div>
      <div style={{ display: 'flex', gap: 8 }}>
        <Tooltip title="Tout transformer">
          <Button
            size="small"
            icon={<PlayCircleOutlined />}
            onClick={onTransformAll}
            disabled={isTransformDisabled}
            loading={isTransformLoading}
          >
            Tout transformer
          </Button>
        </Tooltip>
        <Tooltip title="Prévisualiser le mapping">
          <Button
            size="small"
            icon={<EyeOutlined />}
            onClick={onPreviewMapping}
            disabled={isPreviewDisabled}
            loading={isPreviewLoading}
          >
            Prévisualiser
          </Button>
        </Tooltip>
      </div>
    </div>
  );
};

export default AttributeFilters;
